import { SocialLinkData } from "src/components/home/NpHomePageSocialSection"
import { META_DATA } from "src/metadata/constants"

export const socialLinks: SocialLinkData[] = [
  { name: "Instagram", href: META_DATA.socials.instagram, icon: "brand_instagram" },
  { name: "Facebook", href: META_DATA.socials.facebook, icon: "brand_facebook" },
  { name: "TikTok", href: META_DATA.socials.tiktok, icon: "brand_tiktok" },
  { name: "YouTube", href: META_DATA.socials.youtube, icon: "brand_youtube" },
]
